/*jshint esversion: 6 */
"use strict";
import "./blocks/blocks.js";

document.addEventListener('DOMContentLoaded', function () {

	const menuBtn = document.querySelector('.main-menu-toggle-btn');
	const mainMenu = document.querySelector('.main-menu-modal');
	if (menuBtn && mainMenu) {
		menuBtn.onclick = function() {
			let menuBtnText = document.querySelector('.main-menu-toggle-btn span');
			let menuBtnNav = document.querySelector('.main-menu-toggle');
			let menuCloseIcon = document.querySelector('svg.menu-close-icon');
			let menuOpenIcon = document.querySelector('svg.menu-open-icon');
			mainMenu.classList.toggle('hide-menu');
			menuCloseIcon.classList.toggle('hidden');
			menuOpenIcon.classList.toggle('hidden');
			menuBtnNav.classList.toggle('has-primary-background-color');
			menuBtnNav.classList.toggle('has-base-background-color');
			menuBtnNav.classList.toggle('has-base-color');
			menuBtnNav.classList.toggle('has-primary-color');
			document.body.classList.toggle('menu-open');
			menuBtnText.innerHTML = menuBtnText.innerHTML === "Meny" ? "Lukk" : "Meny";
		};
	}

	const input_2_10 = document.getElementById('input_2_10');
	const input_2_11 = document.getElementById('input_2_11');
	const input_2_17 = document.getElementById('input_2_17');

	if (input_2_10 && input_2_11 && input_2_17) {
		const updateInput_2_17 = () => {
			input_2_17.value = `${input_2_10.value} ${input_2_11.value}`;
		};
		input_2_10.addEventListener('input', updateInput_2_17);
		input_2_11.addEventListener('input', updateInput_2_17);
	}

	const employeeLoop = document.querySelector('section.employee-loop');
	if (employeeLoop) {
		employeeLoop.addEventListener("click", function(event) {
			const employee = event.target.closest('li.employee');
			if (employee) {
				if (employee.classList.contains('selected')) {
					document.querySelectorAll('li.employee').forEach(el => el.classList.remove('selected'));
					employeeLoop.classList.remove('description-open');
				} else {
					document.querySelectorAll('li.employee').forEach(el => el.classList.remove('selected'));
					employee.classList.add('selected');
					employeeLoop.classList.add('description-open');
				}
			}
		});
	}

	const choice_2_17_2 = document.getElementById('choice_2_17_2');
	if (choice_2_17_2 && choice_2_17_2.checked) {

		const priceField = document.querySelector('#input_2_1');
		priceField.setAttribute('disabled', 'true');

		const radioButtons = document.querySelectorAll('input[name="input_19"]');
		let selectedValue = null;

		function handleRadioChange(event) {
			selectedValue = event.target.value;
			if (selectedValue === 'Valgfritt beløp') {
				priceField.removeAttribute('disabled');
				priceField.setAttribute('value', '');
				priceField.setAttribute('placeholder', '');
				priceField.focus();
			} else {
				priceField.setAttribute('value', selectedValue);
				priceField.setAttribute('disabled', 'true');
			}
		}

		radioButtons.forEach((radioButton) => {
			radioButton.addEventListener('change', handleRadioChange);
		});

		const checkedRadioButton = Array.from(radioButtons).find(radioButton => radioButton.checked);
		if (checkedRadioButton) {
			selectedValue = checkedRadioButton.value;
		}
	}

	const searchToggles = document.querySelectorAll('details.wp-block-details.is-style-search-toggle');

	const setupSearchToggle = function(details) {
		details.addEventListener('toggle', function(event) {
			if (!(event.target).open) {
				return;
			}
			details.querySelector('input')?.focus();
		});

		if (screen.width < 720) {
			details.setAttribute('open', true);
		} else {
			document.addEventListener('click', function(event) {
				const isClickInside = details.contains(event.target);
				if (!isClickInside && details.open) {
					details.removeAttribute('open');
				}
			}, true);
			details.removeAttribute('open');
		}
	};

	searchToggles.forEach(setupSearchToggle);

}, false);
